/* The cart drawer's script (sections/pp-cart-drawer.liquid). Moved out of the page HTML into this cached file on 2026-10-25 (33 KB per page).
 * The section prints the tag that loads this file with one attribute, data-cfg: JSON with what only Liquid knows (the cart URL, the products that are not
 * pregnancy-safe, the editable texts, the delivery table, the country). It is read below as CFG. */
(function (script) {
var CFG = JSON.parse(script.getAttribute('data-cfg') || '{}');
(function() {
  /* ─── References ─── */
  const drawer    = document.getElementById('pp-cart-drawer');
  const backdrop  = document.querySelector('[data-pp-drawer-backdrop]');
  if (!drawer || !backdrop) return;

  const SECTION_ID = drawer.dataset.sectionId;

  /* ─── Open / Close ─── */
  function hidePregnancyModal() {
    var w = drawer.querySelector('[data-pp-pregnancy-warning]');
    var o = drawer.querySelector('[data-pp-pregnancy-overlay]');
    if (w) w.classList.remove('is-visible');
    if (o) o.classList.remove('is-visible');
  }

  function animateShipBar() {
    var fill = drawer.querySelector('[data-pp-ship-fill]');
    if (!fill) return;
    fill.style.width = '0';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        fill.style.width = fill.dataset.shipTarget + '%';
      });
    });
  }

  function hideShippingModal() {
    var m = drawer.querySelector('[data-pp-shipping-modal]');
    var o = drawer.querySelector('[data-pp-shipping-overlay]');
    if (m) m.classList.remove('is-visible');
    if (o) o.classList.remove('is-visible');
  }
  function hideSubModal() {
    var m = drawer.querySelector('[data-pp-sub-modal]');
    var o = drawer.querySelector('[data-pp-sub-overlay]');
    if (m) m.classList.remove('is-visible');
    if (o) o.classList.remove('is-visible');
  }

  var _drawerTrigger = null;

  function openDrawer() {
    _drawerTrigger = document.activeElement;
    hidePregnancyModal();
    hideShippingModal();
    hideSubModal();
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.classList.add('pp-drawer-open');
    document.documentElement.classList.add('pp-cart-open');   /* hides the Shopify chat launcher while the cart is open */
    drawer.setAttribute('aria-hidden', 'false');
    refreshDrawer();
    checkPregnancyConflict(500);
    setTimeout(animateShipBar, 100);
    requestAnimationFrame(function() {
      var closeBtn = drawer.querySelector('[data-pp-drawer-close]');
      if (closeBtn) closeBtn.focus();
    });
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('pp-drawer-open');
    document.documentElement.classList.remove('pp-cart-open');
    drawer.setAttribute('aria-hidden', 'true');
    hidePregnancyModal();
    hideShippingModal();
    hideSubModal();
    if (_drawerTrigger && typeof _drawerTrigger.focus === 'function') {
      _drawerTrigger.focus();
    }
    _drawerTrigger = null;
  }

  backdrop.addEventListener('click', closeDrawer);
  drawer.addEventListener('click', function(e) {
    if (e.target.closest('[data-pp-drawer-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function(e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusable = drawer.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ─── Expose globally for header integration ─── */
  window.PPCartDrawer = { open: openDrawer, close: closeDrawer };

  /* ─── Intercept header cart link ─── */
  function interceptCartLinks() {
    var cartUrl = CFG.cartUrl;
    document.querySelectorAll('[data-cart-link], a[href="/cart"], a[href="' + cartUrl + '"]').forEach(function(link) {
      if (link.classList.contains('pp-drawer__cart-btn')) return;
      if (link.closest('#pp-cart-drawer') || link.closest('.pp-drawer__footer') || link.closest('.pp-drawer__bottom-bar')) return;
      link.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });
  }
  interceptCartLinks();
  /* Re-intercept after header custom elements upgrade */
  if (window.customElements) {
    setTimeout(interceptCartLinks, 500);
    setTimeout(interceptCartLinks, 1500);
  }

  /* ─── Cart button (drawer footer): force the CURRENT locale's cart URL ───
     The overlay section group can render routes.cart_url without the
     locale prefix (and its render is cache-shared across pages), which would
     send en-dk shoppers to the default-locale (da-dk) cart. Resolve the locale
     path on the client so it always matches the page the shopper is on. */
  drawer.addEventListener('click', function(e) {
    var cb = e.target.closest('.pp-drawer__cart-btn');
    if (!cb) return;
    e.preventDefault();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root.replace(/\/+$/, '') + '/cart';
  });

  /* ─── Also open on theme cart:open event ─── */
  document.addEventListener('cart:open', openDrawer);

  /* ─── Custom Quantity Dropdown ─── */
  var activeQtyDd = null;
  var activeQtyMenu = null;

  function closeAllDropdowns() {
    if (activeQtyMenu && activeQtyDd) {
      activeQtyMenu.style.display = 'none';
      /* Move menu back into its original parent */
      activeQtyDd.appendChild(activeQtyMenu);
    }
    drawer.querySelectorAll('.pp-drawer__qty.is-open').forEach(function(d) {
      d.classList.remove('is-open');
    });
    activeQtyDd = null;
    activeQtyMenu = null;
  }

  drawer.addEventListener('click', function(e) {
    /* Toggle dropdown */
    var trigger = e.target.closest('.pp-drawer__qty-trigger');
    if (trigger) {
      var dd = trigger.closest('.pp-drawer__qty');
      var wasOpen = dd.classList.contains('is-open');
      closeAllDropdowns();
      if (!wasOpen) {
        dd.classList.add('is-open');
        var menu = dd.querySelector('.pp-drawer__qty-menu');
        if (menu) {
          /* Move menu to drawer root so it escapes scroll container clipping */
          drawer.appendChild(menu);
          var triggerRect = trigger.getBoundingClientRect();
          var drawerRect = drawer.getBoundingClientRect();
          menu.style.top = (triggerRect.bottom - drawerRect.top + 4) + 'px';
          menu.style.left = (triggerRect.left - drawerRect.left) + 'px';
          menu.style.display = 'block';
          activeQtyDd = dd;
          activeQtyMenu = menu;
        }
      }
      return;
    }

    /* Pick option */
    var option = e.target.closest('.pp-drawer__qty-option');
    if (option) {
      var dd = option.closest('[data-pp-qty-dropdown]') || activeQtyDd;
      if (dd) {
        var key = dd.dataset.lineKey;
        var newQty = parseInt(option.dataset.ppQtyPick, 10);
        closeAllDropdowns();
        updateCartItem(key, newQty);
      }
      return;
    }

    /* Click outside closes */
    if (!e.target.closest('.pp-drawer__qty')) {
      closeAllDropdowns();
    }
  });

  /* Close on scroll */
  var scrollArea = drawer.querySelector('.pp-drawer__scroll');
  if (scrollArea) {
    scrollArea.addEventListener('scroll', function() { closeAllDropdowns(); });
  }

  /* ─── Remove Item ─── */
  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pp-remove]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.dataset.ppRemove;
    updateCartItem(key, 0);
  });

  /* ─── AJAX Cart Update ─── */
  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      refreshDrawer();
      /* Dispatch event so header updates its count */
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    })
    .catch(console.error);
  }

  /* ─── Section Rendering API: re-render drawer ─── */
  function refreshDrawer(callback) {
    fetch(window.location.pathname + '?sections=' + SECTION_ID)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (window.__ppToggling) return;
        var html = data[SECTION_ID];
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;

        var newDrawer = temp.querySelector('#pp-cart-drawer');
        if (newDrawer) {
          /* Preserve open state */
          var wasOpen = drawer.classList.contains('is-open');
          drawer.querySelector('.pp-drawer__inner').innerHTML = newDrawer.querySelector('.pp-drawer__inner').innerHTML;
          /* Transfer empty class */
          if (newDrawer.classList.contains('is-empty')) {
            drawer.classList.add('is-empty');
          } else {
            drawer.classList.remove('is-empty');
          }
          if (wasOpen) {
            drawer.classList.add('is-open');
          }
          checkPregnancyConflict(100);
          animateShipBar();
          initPlanToggle();
          if (typeof callback === 'function') callback();
        }
      });
  }

  /* Single point of refresh: internal callers dispatch cart:updated directly; the fetch wrapper below translates third-party /cart/* calls into the same event. */
  document.addEventListener('cart:updated', function(e) {
    if (window.__ppToggling) return;
    var src = e.detail && e.detail.source;
    if (src === 'fetch-add') {
      var shouldOpen = !window.__ppSkipDrawer;
      refreshDrawer(shouldOpen ? openDrawer : null);
    } else if (drawer.classList.contains('is-open')) {
      refreshDrawer();
    }
  });

  /* Fetch translator: catches third-party /cart/* calls (e.g. otsb-product-cart) that don't dispatch cart:updated. */
  var _origFetch = window._ppOrigFetch || window.fetch;
  window._ppOrigFetch = _origFetch;
  window.fetch = function() {
    var args = arguments;
    return _origFetch.apply(this, args).then(function(response) {
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      if (url.includes('/cart/add')) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'fetch-add' } }));
      } else if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'fetch-mutate' } }));
      }
      return response;
    });
  };

  /* ─── Pregnancy Conflict Detection ─── */
  /* Only triggers when the Pregnancy Multivitamin is in the cart alongside
     products not recommended during pregnancy. Dismissed state persists
     across page loads via sessionStorage. */
  var pregnancyTriggerHandle = 'pregnancy-multivitamin';
  var unsafeProductHandles = CFG.unsafeHandles;

  var pregnancyWarningTexts = CFG.pregnancy;

  var pregnancyAutoTimer = null;
  /* Restore warned handles from sessionStorage so dismiss persists across pages */
  var pregnancyWarnedHandles = (function() {
    try {
      var stored = sessionStorage.getItem('pp_pregnancy_warned');
      return stored ? JSON.parse(stored) : [];
    } catch(e) { return []; }
  })();

  function savePregnancyWarned() {
    try { sessionStorage.setItem('pp_pregnancy_warned', JSON.stringify(pregnancyWarnedHandles)); } catch(e) {}
  }

  function checkPregnancyConflict(delay) {
    var warning = drawer.querySelector('[data-pp-pregnancy-warning]');
    var textEl = drawer.querySelector('[data-pp-pregnancy-text]');
    if (!warning || !textEl) return;

    /* Collect all product handles currently in the cart drawer */
    var handles = [];
    drawer.querySelectorAll('[data-ingredient-handle]').forEach(function(el) {
      handles.push(el.dataset.ingredientHandle);
    });
    drawer.querySelectorAll('[data-line-item-handle]').forEach(function(el) {
      handles.push(el.dataset.lineItemHandle);
    });

    /* Only trigger if the Pregnancy Multivitamin is actually in the cart */
    var hasPregnancyProduct = handles.indexOf(pregnancyTriggerHandle) !== -1;
    var unsafeHandlesNow = [];
    var unsafeNames = [];
    drawer.querySelectorAll('[data-ingredient-handle]').forEach(function(el) {
      if (unsafeProductHandles.indexOf(el.dataset.ingredientHandle) !== -1) {
        unsafeHandlesNow.push(el.dataset.ingredientHandle);
        var nameEl = el.querySelector('.pp-drawer__ingredient-name');
        if (nameEl) unsafeNames.push(nameEl.textContent.trim());
      }
    });
    drawer.querySelectorAll('[data-line-item-handle]').forEach(function(el) {
      if (unsafeProductHandles.indexOf(el.dataset.lineItemHandle) !== -1) {
        unsafeHandlesNow.push(el.dataset.lineItemHandle);
        var nameEl = el.querySelector('.pp-drawer__item-title');
        if (nameEl) unsafeNames.push(nameEl.textContent.trim());
      }
    });

    /* Only show if there are NEW unsafe products not yet warned about */
    var hasNew = unsafeHandlesNow.some(function(h) { return pregnancyWarnedHandles.indexOf(h) === -1; });

    if (hasPregnancyProduct && unsafeNames.length > 0 && hasNew) {
      var names = '<strong>' + unsafeNames.join(', ') + '</strong>';
      var verb = unsafeNames.length === 1 ? 'is' : 'are';
      var pronoun = unsafeNames.length === 1 ? 'it' : 'them';
      textEl.innerHTML =
        pregnancyWarningTexts.prefix + ' ' + names + ' ' + verb + ' ' + pregnancyWarningTexts.notRecommended +
        '<br><br>' +
        pregnancyWarningTexts.removePrefix + ' ' + pronoun + ' ' + pregnancyWarningTexts.exploreSuffix + ' <a href="' + pregnancyWarningTexts.linkUrl + '">' + pregnancyWarningTexts.linkText + '</a> ' + pregnancyWarningTexts.instead;
      var showFn = function() {
        warning.classList.add('is-visible');
        var overlay = drawer.querySelector('[data-pp-pregnancy-overlay]');
        if (overlay) overlay.classList.add('is-visible');
        /* Auto-dismiss after 30 seconds */
        if (pregnancyAutoTimer) clearTimeout(pregnancyAutoTimer);
        pregnancyAutoTimer = setTimeout(function() {
          dismissPregnancyModal();
        }, 30000);
      };
      if (delay) { setTimeout(showFn, delay); } else { showFn(); }
    } else {
      warning.classList.remove('is-visible');
      var overlay = drawer.querySelector('[data-pp-pregnancy-overlay]');
      if (overlay) overlay.classList.remove('is-visible');
    }
  }

  function dismissPregnancyModal() {
    if (pregnancyAutoTimer) { clearTimeout(pregnancyAutoTimer); pregnancyAutoTimer = null; }
    var w = drawer.querySelector('[data-pp-pregnancy-warning]');
    var o = drawer.querySelector('[data-pp-pregnancy-overlay]');
    if (w) w.classList.remove('is-visible');
    if (o) o.classList.remove('is-visible');
    /* Remember which handles were warned about so we don't repeat (persists in session) */
    drawer.querySelectorAll('[data-ingredient-handle]').forEach(function(el) {
      if (unsafeProductHandles.indexOf(el.dataset.ingredientHandle) !== -1 && pregnancyWarnedHandles.indexOf(el.dataset.ingredientHandle) === -1) {
        pregnancyWarnedHandles.push(el.dataset.ingredientHandle);
      }
    });
    drawer.querySelectorAll('[data-line-item-handle]').forEach(function(el) {
      if (unsafeProductHandles.indexOf(el.dataset.lineItemHandle) !== -1 && pregnancyWarnedHandles.indexOf(el.dataset.lineItemHandle) === -1) {
        pregnancyWarnedHandles.push(el.dataset.lineItemHandle);
      }
    });
    savePregnancyWarned();
  }

  drawer.addEventListener('click', function(e) {
    if (e.target.closest('[data-pp-pregnancy-dismiss]') || e.target.closest('[data-pp-pregnancy-overlay]')) {
      dismissPregnancyModal();
    }
  });

  /* ─── Shipping Info Modal ─── */
  function openShippingModal() {
    var modal = drawer.querySelector('[data-pp-shipping-modal]');
    var overlay = drawer.querySelector('[data-pp-shipping-overlay]');
    if (modal) modal.classList.add('is-visible');
    if (overlay) overlay.classList.add('is-visible');
  }
  function closeShippingModal() {
    var modal = drawer.querySelector('[data-pp-shipping-modal]');
    var overlay = drawer.querySelector('[data-pp-shipping-overlay]');
    if (modal) modal.classList.remove('is-visible');
    if (overlay) overlay.classList.remove('is-visible');
  }
  drawer.addEventListener('click', function(e) {
    if (e.target.closest('[data-pp-ship-info-trigger]')) {
      e.preventDefault();
      openShippingModal();
    }
    if (e.target.closest('[data-pp-shipping-dismiss]') || e.target.closest('[data-pp-shipping-overlay]')) {
      closeShippingModal();
    }
  });

  /* ─── Subscription Info Modal ─── */
  function openSubModal() {
    var modal = drawer.querySelector('[data-pp-sub-modal]');
    var overlay = drawer.querySelector('[data-pp-sub-overlay]');
    if (modal) modal.classList.add('is-visible');
    if (overlay) overlay.classList.add('is-visible');
  }
  function closeSubModal() {
    var modal = drawer.querySelector('[data-pp-sub-modal]');
    var overlay = drawer.querySelector('[data-pp-sub-overlay]');
    if (modal) modal.classList.remove('is-visible');
    if (overlay) overlay.classList.remove('is-visible');
  }
  drawer.addEventListener('click', function(e) {
    if (e.target.closest('[data-pp-sub-info-trigger]')) {
      e.preventDefault();
      openSubModal();
    }
    if (e.target.closest('[data-pp-sub-dismiss]') || e.target.closest('[data-pp-sub-overlay]')) {
      closeSubModal();
    }
  });

  /* ─── Discount Code ─── */
  drawer.addEventListener('click', function(e) {
    if (e.target.closest('[data-pp-discount-btn]')) { applyDiscount(); return; }
    if (e.target.closest('[data-pp-remove-discount]')) { removeDiscount(); return; }
  });

  drawer.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && e.target.closest('[data-pp-discount-input]')) {
      e.preventDefault();
      applyDiscount();
    }
  });

  function applyDiscount() {
    var input = drawer.querySelector('[data-pp-discount-input]');
    var btn = drawer.querySelector('[data-pp-discount-btn]');
    var msg = drawer.querySelector('[data-pp-discount-msg]');
    if (!input || !btn) return;

    var code = input.value.trim();
    if (!code) return;

    btn.disabled = true;
    btn.textContent = '...';

    /* Apply discount via Shopify's /discount/CODE endpoint (sets cookie) */
    var totalBefore = null;
    fetch('/cart.js').then(function(r) { return r.json(); })
      .then(function(cartBefore) {
        totalBefore = cartBefore.total_price;
        return fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
      })
      .then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        var applied = false;
        /* Check cart-level discount applications */
        var apps = cart.cart_level_discount_applications || [];
        for (var i = 0; i < apps.length; i++) {
          if (apps[i].title.toLowerCase() === code.toLowerCase()) { applied = true; break; }
        }
        /* Check line-item-level discount allocations */
        if (!applied && cart.items) {
          for (var j = 0; j < cart.items.length; j++) {
            var allocs = cart.items[j].discount_allocations || [];
            for (var k = 0; k < allocs.length; k++) {
              var appIdx = allocs[k].discount_application_index;
              if (appIdx !== undefined) {
                var da = (cart.discount_applications || [])[appIdx];
                if (da && da.title && da.title.toLowerCase() === code.toLowerCase()) { applied = true; break; }
              }
            }
            if (applied) break;
          }
        }
        /* Fallback: total dropped means code worked */
        if (!applied && totalBefore !== null && cart.total_price < totalBefore) { applied = true; }

        if (applied) {
          input.value = '';
          refreshDrawer(function() {
            var newMsg = drawer.querySelector('[data-pp-discount-msg]');
            showDiscountMsg(newMsg, 'success', CFG.discountSuccess);
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        } else {
          showDiscountMsg(msg, 'error', CFG.discountInvalid);
        }
      })
      .catch(function() {
        showDiscountMsg(msg, 'error', CFG.discountGeneric);
      })
      .finally(function() {
        btn.disabled = false;
        btn.textContent = CFG.discountBtn;
      });
  }

  function removeDiscount() {
    /* Remove the applied code via the Cart AJAX API discount parameter,
       then re-render the drawer. */
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function() { refreshDrawer(); document.dispatchEvent(new CustomEvent('cart:updated')); })
      .catch(function() { refreshDrawer(); });
  }

  function showDiscountMsg(el, type, text) {
    if (!el) return;
    el.textContent = text;
    el.className = 'pp-drawer__discount-msg pp-drawer__discount-msg--' + type;
    el.style.display = 'block';
    setTimeout(function() { el.style.display = 'none'; }, 5000);
  }

  /* ─── Delivery Estimate ─── */
  var deliveryDaysMap = CFG.deliveryDays;
  var deliveryEstimatePrefix = CFG.deliveryPrefix;
  var deliveryMonthNames = CFG.deliveryMonths.split(',');

  function updateDeliveryEstimate(container) {
    var el = container.querySelector('[data-pp-delivery-estimate]');
    var textEl = container.querySelector('[data-pp-delivery-text]');
    if (!el || !textEl) return;

    var country = (window.Shopify && window.Shopify.country) || CFG.country;
    var range = deliveryDaysMap[country];
    if (!range) {
      el.style.display = 'none';
      return;
    }

    var now = new Date();

    function addBusinessDays(start, days) {
      var d = new Date(start);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) {
          added++;
        }
      }
      return d;
    }

    var from = addBusinessDays(now, range[0]);
    var to = addBusinessDays(now, range[1]);

    function fmt(d) {
      return d.getDate() + '. ' + deliveryMonthNames[d.getMonth()];
    }

    textEl.textContent = deliveryEstimatePrefix + ' ' + fmt(from) + ' – ' + fmt(to);
    el.style.display = '';
  }

  updateDeliveryEstimate(drawer);

  /* Re-run after drawer refresh */
  var _origRefreshDrawer = refreshDrawer;
  refreshDrawer = function(cb) {
    _origRefreshDrawer(function() {
      updateDeliveryEstimate(drawer);
      initPlanToggle();
      if (typeof cb === 'function') cb();
    });
  };

  /* ─── Plan Subscription Toggle ─── */
  function initPlanToggle() {
    var toggle = drawer.querySelector('[data-pp-plan-toggle]');
    if (!toggle || toggle.dataset.ppInited) return;
    toggle.dataset.ppInited = '1';
    var bubble = toggle.querySelector('[data-pp-toggle-bubble]');
    var words = toggle.querySelectorAll('.pp-drawer__plan-toggle-word');
    if (!bubble || words.length < 2) return;

    /* Position bubble on active word */
    function positionBubble(el, snap) {
      var tRect = toggle.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      var left = r.left - tRect.left;
      var top = r.top - tRect.top;
      if (snap) {
        bubble.style.transition = 'none';
        bubble.style.left = left + 'px';
        bubble.style.width = r.width + 'px';
        bubble.style.top = top + 'px';
        bubble.style.height = r.height + 'px';
        bubble.offsetHeight;
        bubble.style.transition = '';
      } else {
        bubble.style.left = left + 'px';
        bubble.style.width = r.width + 'px';
        bubble.style.top = top + 'px';
        bubble.style.height = r.height + 'px';
      }
      words.forEach(function(w) { w.classList.remove('is-active'); });
      el.classList.add('is-active');
    }

    /* Init position */
    var activeWord = toggle.querySelector('.pp-drawer__plan-toggle-word.is-active') || words[0];
    var currentActive = activeWord;
    positionBubble(activeWord, true);

    /* Move bubble to element without changing active state */
    function moveBubbleTo(el, snap) {
      var tRect = toggle.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      if (snap) {
        bubble.style.transition = 'none';
        bubble.style.left = (r.left - tRect.left) + 'px';
        bubble.style.width = r.width + 'px';
        bubble.style.top = (r.top - tRect.top) + 'px';
        bubble.style.height = r.height + 'px';
        bubble.offsetHeight;
        bubble.style.transition = '';
      } else {
        bubble.style.left = (r.left - tRect.left) + 'px';
        bubble.style.width = r.width + 'px';
        bubble.style.top = (r.top - tRect.top) + 'px';
        bubble.style.height = r.height + 'px';
      }
    }

    /* Hover: bubble follows mouse, returns on leave */
    words.forEach(function(w) {
      w.addEventListener('mouseenter', function() {
        if (toggling) return;
        moveBubbleTo(w, false);
        words.forEach(function(x) { x.classList.remove('is-active'); });
        w.classList.add('is-active');
      });
    });
    toggle.addEventListener('mouseleave', function() {
      if (toggling) return;
      moveBubbleTo(currentActive, false);
      words.forEach(function(x) { x.classList.remove('is-active'); });
      currentActive.classList.add('is-active');
    });

    /*
     * Synchronous-style XHR helpers — completely bypass any fetch wrappers/interceptors.
     * Each call blocks the Promise chain until the server confirms the operation.
     */
    function xhrPost(url, body) {
      return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function() {
          if (xhr.status >= 200 && xhr.status < 300) {
            try { resolve(JSON.parse(xhr.responseText)); }
            catch(e) { resolve(null); }
          } else { reject(new Error('XHR ' + xhr.status)); }
        };
        xhr.onerror = function() { reject(new Error('XHR network error')); };
        xhr.send(body ? JSON.stringify(body) : '');
      });
    }
    function xhrGet(url) {
      return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onload = function() {
          if (xhr.status >= 200 && xhr.status < 300) {
            try { resolve(JSON.parse(xhr.responseText)); }
            catch(e) { resolve(null); }
          } else { reject(new Error('XHR ' + xhr.status)); }
        };
        xhr.onerror = function() { reject(new Error('XHR network error')); };
        xhr.send();
      });
    }

    /* Click handler */
    var toggling = false;
    toggle.addEventListener('click', function(e) {
      var word = e.target.closest('.pp-drawer__plan-toggle-word');
      if (!word || word === currentActive || toggling) return;
      toggling = true;

      currentActive = word;
      positionBubble(word, false);

      var opt = word.getAttribute('data-pp-toggle-opt');
      var isSub = (opt === 'subscription');
      var keysStr = toggle.getAttribute('data-plan-line-keys') || '';
      var planKeys = {};
      keysStr.split(',').filter(Boolean).forEach(function(k) { planKeys[k] = true; });

      /* Per-variant selling-plan map + plan-variant set so each product keeps its own plan */
      var planMap = {};
      try { planMap = JSON.parse(toggle.getAttribute('data-plan-selling-plans') || '{}'); } catch (e) { planMap = {}; }
      var variantSet = {};
      (toggle.getAttribute('data-plan-variant-ids') || '').split(',').filter(Boolean).forEach(function(v) { variantSet[v] = true; });

      function lineIsPlan(item) {
        return !!(planKeys[item.key]
          || (item.properties && item.properties._plan === 'true')
          || variantSet[String(item.variant_id)]);
      }
      function desiredPlanFor(variantId) {
        if (!isSub) return null;
        var v = planMap[variantId];
        if (v === undefined) v = planMap[String(variantId)];
        return (v === undefined || v === null) ? null : v;
      }

      /* Dim the plan card */
      var planCard = toggle.closest('.pp-drawer__plan-card');
      if (planCard) { planCard.style.transition = 'opacity 0.15s'; planCard.style.opacity = '0.5'; }

      /* Block ALL interceptor activity */
      window.__ppToggling = true;

      /*
       * Change each plan line's selling plan IN PLACE via /cart/change.js. This is
       * non-destructive: unlike the old remove-then-re-add, a failure on one line
       * leaves the rest of the plan intact instead of wiping it. change.js requires
       * identifying the line by its 1-based `line` index and re-keys the line, so we
       * re-fetch the cart after each change and process one line at a time.
       */
      var failedVariants = {};
      function applyNextChange(guard) {
        guard = guard || 0;
        if (guard > 60) return Promise.resolve(null);
        return xhrGet('/cart.js').then(function(cart) {
          if (!cart || !cart.items) return null;
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            if (!lineIsPlan(item) || failedVariants[item.variant_id]) continue;
            var want = desiredPlanFor(item.variant_id);
            var cur = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null;
            if (want === cur) continue;
            return xhrPost('/cart/change.js', {
              line: i + 1,
              quantity: item.quantity,
              selling_plan: want,
              properties: item.properties
            }).then(function() {
              return applyNextChange(guard + 1);
            }).catch(function() {
              failedVariants[item.variant_id] = true;
              return applyNextChange(guard + 1);
            });
          }
          return null; /* every plan line already matches the desired state */
        });
      }

      applyNextChange(0)
        .then(function() {
          /* Refresh drawer via XHR section render (bypasses fetch interceptor) */
          return xhrGet(window.location.pathname + '?sections=' + SECTION_ID);
        })
        .then(function(data) {
          var html = data && data[SECTION_ID];
          if (html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var newDrawer = temp.querySelector('#pp-cart-drawer');
            if (newDrawer) {
              drawer.querySelector('.pp-drawer__inner').innerHTML = newDrawer.querySelector('.pp-drawer__inner').innerHTML;
              if (newDrawer.classList.contains('is-empty')) {
                drawer.classList.add('is-empty');
              } else {
                drawer.classList.remove('is-empty');
              }
              drawer.classList.add('is-open');
              checkPregnancyConflict(100);
              animateShipBar();
              initPlanToggle();
            }
          }
          window.__ppToggling = false;
          toggling = false;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function(err) {
          console.error('[PP Toggle Error]', err);
          window.__ppToggling = false;
          toggling = false;
          if (planCard) planCard.style.opacity = '';
          refreshDrawer();
        });
    });
  }
  initPlanToggle();

})();
})(document.currentScript);
